<template>
  <div class="floating-actions" v-if="selectedFiles.length > 0">
    <div class="floating-container">
      <!-- Selection Count Badge -->
      <div class="selection-badge">
        <i class="fas fa-check-circle"></i>
        <span>{{ selectedFiles.length }}</span>
      </div>
      
      <!-- Download Button -->
      <button
        class="floating-btn floating-download-btn"
        @click="$emit('bulk-download')"
        title="ดาวน์โหลดไฟล์ที่เลือก"
      >
        <i class="fas fa-download"></i>
      </button>
      
      <!-- Delete Button -->
      <button
        class="floating-btn floating-delete-btn"
        @click="$emit('bulk-delete')"
        title="ลบไฟล์ที่เลือก"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GalleryActions",
  props: {
    selectedFiles: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["bulk-download", "bulk-delete"],
};
</script>

<style scoped>
.floating-actions {
  position: fixed;
  bottom: 2rem;
  right: 0.5rem;
  z-index: 1000;
  animation: slideUp 0.3s ease-out;
  max-width: calc(100vw - 1rem);
  overflow: visible;
}

.floating-container {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  padding: 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  width: auto;
  min-width: fit-content;
  overflow: visible;
}


.selection-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #007bff;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  flex-shrink: 0;
}

.selection-badge i {
  font-size: 0.8rem;
}

.floating-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.floating-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 0;
}

.floating-btn i {
  position: relative;
  z-index: 1;
}

.floating-download-btn {
  background: #007bff;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.floating-download-btn:hover {
  background: #0056b3;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.5);
}

.floating-delete-btn {
  background: #dc3545;
  color: white;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.floating-delete-btn:hover {
  background: #c82333;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.5);
}

.floating-btn:active {
  transform: translateY(0) scale(0.95);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .floating-actions {
    bottom: 1.5rem;
    right: 1rem;
    left: 1rem;
  }
  
  .floating-container {
    justify-content: center;
    padding: 0.4rem;
    gap: 0.25rem;
  }
  
  .selection-badge {
    padding: 0.3rem 0.5rem;
    font-size: 0.75rem;
  }
  
  .floating-btn {
    width: 36px;
    height: 36px;
    font-size: 0.8rem;
  }
}

@media (max-width: 576px) {
  .floating-actions {
    bottom: 1rem;
    right: 0.5rem;
    left: 0.5rem;
  }
  
  .floating-container {
    padding: 0.35rem;
    gap: 0.2rem;
  }
  
  .selection-badge {
    padding: 0.25rem 0.4rem;
    font-size: 0.7rem;
  }
  
  .floating-btn {
    width: 32px;
    height: 32px;
    font-size: 0.75rem;
  }
}

/* Hide scrollbar interaction on mobile to prevent issues */
@media (max-width: 768px) {
  .floating-actions {
    position: fixed;
  }
}
</style>